var alertTriggers = [];
export var registerAlertTrigger = function (trigger) {
    alertTriggers.push(trigger);
};
export var showAlert = function (alert) {
    alertTriggers.forEach(function (alertTrigger) {
        alertTrigger(alert);
    });
};
